module.exports = __webpack_public_path__ + "img/20190515162742b_03.7eddb975.png";